import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '3',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Pricing sheet',
    colSize: '21',
    sortable: true,
    sort: 'desc',
    sortName: 'price_sheet_name_number',
    active: false,
    col: 'price_sheet_name_number',
    data: (row: any) => {
      const priceSheetName = _.get(row, 'price_sheet_name');
      const priceSheetNumber = _.get(row, 'price_sheet_number');
      return `${priceSheetName} (${priceSheetNumber})`;
    }
  },
  {
    title: 'Last updated',
    colSize: '8',
    sortable: true,
    sort: 'desc',
    sortName: 'updated_at',
    active: false,
    col: 'updated_at'
  },
];
